import { render, staticRenderFns } from "./product_live_show.vue?vue&type=template&id=c2702906"
import script from "./product_live_show.vue?vue&type=script&lang=js"
export * from "./product_live_show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports